// src/utils/loadJsPdf.js
// Gemeinsamer Lazy-Loader für jsPDF (Code-Splitting). Nach einem Deploy
// existiert der alte Chunk (z.B. assets/jspdf.es.min-<hash>.js) nicht mehr;
// ein Tab, der noch die alte index.html geladen hat, bekommt dann
// "Failed to fetch dynamically imported module". Ein Retry hilft nicht
// (Datei ist weg) — nur ein Neuladen der Seite holt die neuen Chunk-Namen.

const CHUNK_ERROR_PATTERN =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Loading chunk .* failed/i;

export function isChunkLoadError(err) {
  return CHUNK_ERROR_PATTERN.test(String(err?.message || err || ""));
}

export async function loadJsPdf() {
  try {
    const { jsPDF } = await import("jspdf");
    return jsPDF;
  } catch (err) {
    if (isChunkLoadError(err)) {
      const friendly = new Error(
        "Die Anwendung wurde inzwischen aktualisiert. Bitte die Seite neu laden (F5) und den PDF-Export erneut starten"
      );
      friendly.cause = err;
      friendly.isChunkLoadError = true;
      throw friendly;
    }
    throw err;
  }
}
